import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { token, isAuthReady } = useAuth();

  // ⏳ wait until auth is restored
 if (!isAuthReady) {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      Loading...
    </div>
  );
}


  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
